import React from 'react';
import styles from './style.module.scss';
import { listingCardIds } from 'constants/test-constants';
import ProviderLogo from '../provider-logo';
import { getMlsNumberPrefix } from 'ui/mls-info/format-mls-info';

export type ProviderProps = {
  mlsNum: string | null;
  /** Feed the listing came from — decides the listing-number prefix. */
  providerId?: number | null;
  brokerage: string | null;
  src?: string | null;
  alt?: string | null;
};

function ProviderLabel({ mlsNum, providerId, brokerage, className }: Pick<ProviderProps, 'mlsNum' | 'providerId' | 'brokerage'> & { className?: string }) {
  return (
    <p className={className}>{getMlsNumberPrefix(providerId)}&nbsp;
      <span data-testid={listingCardIds.listingMlsNum}>{mlsNum} {brokerage}</span>
    </p>
  );
}

export default function Provider({ mlsNum, providerId, brokerage = '', src, alt }: ProviderProps) {

  return (
    <div className={styles.container}>
      {mlsNum &&
        <ProviderLabel mlsNum={mlsNum} providerId={providerId} brokerage={brokerage} className={styles.label} />
      }
      <ProviderLogo src={src} alt={alt} />
    </div>
  );
}
